import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PolicySorter from './PolicySorter';
import PolicyScanner from './PolicyScanner';
import PCIDSSAnalyser from './PCIDSSAnalyser';
import DeepExplain from './DeepExplain';
import DeepEx from './DeepEx';
import NotFound from './NotFound'; // Import the NotFound page
import usePageTracking from './usePageTracking';

function App() {
  return (
    <Router>
      {/* Use a separate child component where the hook can run in Router context */}
      <AppRoutes />
    </Router>
  );
}

function AppRoutes() {
  usePageTracking(); // now inside Router
  return (
    <Routes>
      <Route path="/" element={<PolicySorter />} />
      <Route path="/scan" element={<PolicyScanner />} />
      <Route path="/pci" element={<PCIDSSAnalyser />} />
      <Route path="/aiexplain" element={<DeepExplain />} />
      <Route path="/deepex" element={<DeepEx />} />
      {/* Catch-all route for unknown paths */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default App;
